import { projectApi } from '@highlight-cp/project-api';

import { useGetCurrentProjectId } from '../use-get-current-project-id';

const useGetSurveys = () => {
  const projectId = useGetCurrentProjectId();

  return projectApi.useGetProjectsByProjectIdSurveysQuery(
    { projectId: projectId ?? 0 },
    { skip: !projectId },
  );
};

export default useGetSurveys;
